import mediaQueryBuilder from 'styles/helpers/mediaQueryBuilder';
import styled from '@emotion/styled';

const ThumbsContainer = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',

  ':first-of-type': {
    marginRight: '0.75rem',
  },

  [mediaQueryBuilder(theme.mediaQueries.max.width['768'])]: {
    display: 'none',
    marginLeft: '2rem',
  },
}));

export default ThumbsContainer;
